import { Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Configuration } from 'config/config';
//import * as $ from 'jquery/dist/jquery.min.js';

@Injectable()
export class AppUtils {

  public static getError(response): string {
    let errorMessage = "Please try again!";
    if (!AppUtils.isUndefinedOrNull(response) && !AppUtils.isUndefinedOrNull(response.message)) {
      errorMessage = response.message;
      if (!AppUtils.isUndefinedOrNull(response.submessage)) {
        errorMessage = response.submessage + (response.submessage.endsWith(".") ? " " : ". ") + errorMessage;
      }
    }

    return errorMessage;
  }

  /**
   * Extracts a user-facing message from HTTP errors, NestJS responses, or legacy API bodies.
   */
  public static getHttpErrorMessage(
    error: unknown,
    fallback = 'Something went wrong. Please try again.',
  ): string {
    if (error == null) {
      return fallback;
    }

    if (typeof error === 'string') {
      return error.trim() || fallback;
    }

    const err = error as Record<string, unknown>;
    const body = err.error !== undefined ? err.error : error;

    if (typeof body === 'string') {
      return body.trim() || fallback;
    }

    if (body && typeof body === 'object') {
      const bodyObj = body as Record<string, unknown>;

      if (bodyObj.message != null) {
        if (Array.isArray(bodyObj.message)) {
          const messages = bodyObj.message
            .filter((item): item is string => typeof item === 'string' && item.trim().length > 0);
          if (messages.length > 0) {
            return messages.join(', ');
          }
        } else if (typeof bodyObj.message === 'string' && bodyObj.message.trim()) {
          return bodyObj.message.trim();
        }
      }

      const genericHttpErrors = new Set([
        'Unauthorized',
        'Bad Request',
        'Internal Server Error',
        'Forbidden',
        'Not Found',
      ]);
      if (
        typeof bodyObj.error === 'string' &&
        bodyObj.error.trim() &&
        !genericHttpErrors.has(bodyObj.error)
      ) {
        return bodyObj.error.trim();
      }

      const legacyMessage = AppUtils.getError(bodyObj);
      if (legacyMessage !== 'Please try again!') {
        return legacyMessage;
      }
    }

    if (typeof err.message === 'string' && err.message.trim()) {
      const message = err.message.trim();
      if (!message.startsWith('Http failure response')) {
        return message;
      }
    }

    return fallback;
  }

  public static isLicenceError(message: string): boolean {
    const text = (message || '').toLowerCase();
    return (
      text.includes('licence is expired') ||
      text.includes('license is expired') ||
      text.includes('license is suspended') ||
      text.includes('licence has been deacivated') ||
      text.includes('macaddress is invalid')
    );
  }

  public static isUndefined(value): boolean {
    return value === undefined;
  }

  public static isUndefinedOrNull(value): boolean {
    if (value === undefined || value === null) {
      return true;
    }
    if (typeof value === 'string' || Array.isArray(value)) {
      return value.length === 0;
    }
    if (typeof value === 'object') {
      return Object.keys(value).length === 0;
    }
    return false;
  }

  public static calculateAge(dateOfBirth: Date): number {
    const today = new Date();
    let age = today.getFullYear() - dateOfBirth.getFullYear();
    const monthDifference = today.getMonth() - dateOfBirth.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dateOfBirth.getDate())) {
      age--;
    }
    return age;
  }

  public static validateMemberAgeAgainstPackage(
    member: { dateOfBirth?: Date | string },
    packageData: { ageGroupFrom?: number; ageGroupTo?: number }
  ): { isValid: boolean; age: number | null; isTooYoung: boolean; isTooOld: boolean } {
    if (!member || !member.dateOfBirth || !packageData) {
      return { isValid: true, age: null, isTooYoung: false, isTooOld: false };
    }

    if (packageData.ageGroupFrom == null && packageData.ageGroupTo == null) {
      return { isValid: true, age: null, isTooYoung: false, isTooOld: false };
    }

    const birthDate = new Date(member.dateOfBirth as any);
    if (isNaN(birthDate.getTime())) {
      return { isValid: true, age: null, isTooYoung: false, isTooOld: false };
    }

    const age = AppUtils.calculateAge(birthDate);
    const hasMin = typeof packageData.ageGroupFrom === "number";
    const hasMax = typeof packageData.ageGroupTo === "number";
    const isTooYoung = hasMin && age < (packageData.ageGroupFrom as number);
    const isTooOld = hasMax && age > (packageData.ageGroupTo as number);
    return { isValid: !isTooYoung && !isTooOld, age, isTooYoung, isTooOld };
  }

      // setting img paths

      setImagesPath(company, branch) {
        // path images
        localStorage.setItem('cnicImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/cnic/');
        // localStorage.setItem('covidImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/covid/');
        localStorage.setItem('feereceiptImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/feereceipts/');
        localStorage.setItem('trainerFeeReceiptImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/trainer-fee/');
        localStorage.setItem('pettyImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/PettyExpense/');
        localStorage.setItem('memberImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/members/');
        localStorage.setItem('assetImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/assets/');
        localStorage.setItem('employeeImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/employees/');
        localStorage.setItem('userImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/users/');
        localStorage.setItem('trainerImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/trainers/');
        localStorage.setItem('productImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/products/');
        localStorage.setItem('companyImagePath', 'assets/layout/images/companies/');
        localStorage.setItem('branchImagePath', 'assets/layout/images/companies/');

        const configurations = new Configuration();

        configurations.cnicImagePath = localStorage.getItem('cnicImagePath');
        // configurations.covidImagePath = localStorage.getItem('covidImagePath');
        configurations.feereceiptImagePath = localStorage.getItem('feereceiptImagePath');
        configurations.trainerFeeReceiptImagePath = localStorage.getItem('trainerFeeReceiptImagePath');
        configurations.pettyImagePath = localStorage.getItem('pettyImagePath');
        configurations.assetImagePath = localStorage.getItem('assetImagePath');
        configurations.memberImagePath = localStorage.getItem('memberImagePath');
        configurations.employeeImagePath = localStorage.getItem('employeeImagePath');
        configurations.userImagePath = localStorage.getItem('userImagePath');
        configurations.trainerImagePath = localStorage.getItem('trainerImagePath');
        configurations.productImagePath = localStorage.getItem('productImagePath');
        configurations.companyImagePath = localStorage.getItem('companyImagePath');
        configurations.branchImagePath = localStorage.getItem('branchImagePath');


    }

  public static markAsDirty(group: UntypedFormGroup) {
    group.markAsDirty();
    for (const i in group.controls) {
      if (group.controls[i] instanceof UntypedFormControl) {
        group.controls[i].markAsDirty();
      } else if (group.controls[i] instanceof UntypedFormGroup) {
        AppUtils.markAsDirty(<UntypedFormGroup>group.controls[i]);
      }
    }
  }
  public static markAsUntouch(group: UntypedFormGroup) {
    group.markAsDirty();
    for (const i in group.controls) {
      if (group.controls[i] instanceof UntypedFormControl) {
        group.controls[i].markAsUntouched();
      } else if (group.controls[i] instanceof UntypedFormGroup) {
        AppUtils.markAsUntouch(<UntypedFormGroup>group.controls[i]);
      }
    }
  } public static markAsTouch(group: UntypedFormGroup) {
    group.markAsDirty();
    for (const i in group.controls) {
      if (group.controls[i] instanceof UntypedFormControl) {
        group.controls[i].markAsTouched();
      } else if (group.controls[i] instanceof UntypedFormGroup) {
        AppUtils.markAsTouch(<UntypedFormGroup>group.controls[i]);
      }
    }
  }

  public static deepCopy(to: Array<any>, from: Array<any>) {

    for (let i = 0; i < to.length; i++) {
      to.pop();
    }
    to.pop();
    for (let i = 0; i < from.length; i++) {
      to.push(from[i]);
    }
  }

  public static copyDataInForm(data, form) {
    Object.keys(data).forEach(name => {
      if (form.controls[name]) {
        form.controls[name].patchValue(data[name]);
      }
    });
  }

  public static enableForm(group: UntypedFormGroup, enable: boolean) {
    for (const i in group.controls) {
      if (enable) {
        group.controls[i].enable();
      } else {
        group.controls[i].disable();
      }
    }
  }

  public static copyObjectFields(newObject, oldObject) {
    Object.keys(newObject).forEach(name => {
      if (oldObject[name] || oldObject[name] == null) {
        oldObject[name] = newObject[name];
      }
    });
  }

  public static contains(criteriaName: string, array: any): boolean {
    let exists = false;

    if (!AppUtils.isUndefinedOrNull(array)) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === criteriaName) {
          exists = true;
          break;
        }
      }
    }

    return exists;
  }

  public static convertBytesInMB(sizeInBytes: number): number {
    return ((sizeInBytes / 1024) / 1024);
  }

  public static addAlphabaticsChars(charArray) {
    for (let i = 65; i <= 90; i++) {
      charArray.push(String.fromCharCode(i));
    }
  }

  public static convertArrayIntoString(array: string[]): string {
    let str = "";
    const delimeter = ", ";

    for (let i = 0; i < array.length; i++) {
      if (i === (array.length - 1)) {
        str += array[i];
      } else {
        str += array[i] + delimeter;
      }
    }

    return str;
  }

  // public static scrollToElement(element: string, delay: number = 50) {
  //   setTimeout(() => {
  //     $('html, body').animate({
  //       scrollTop: $(element).offset().top - 80
  //     }, 500);
  //   }, delay);

  // }

  public static getFileExtension(fileName: string, addDot: boolean): string {
    return (addDot ? "." : "") + fileName.split('.').pop();
  }

  public static getPercent(value, totalInSeconds: any) {
    return ((value / totalInSeconds) * 100);
  }

  public static getPercentRoundedOf(value, totalInSeconds: any) {
    return ((value / totalInSeconds) * 100).toFixed(2);
  }

  public static deepCloneObject(objectToCopy) {
    return (JSON.parse(JSON.stringify(objectToCopy)));
  }

  public static getCurrentURI(): string {
    return window.location.href;
  }

  public static encodePublicQueryToken(payload: any): string {
    if (!payload || typeof payload !== 'object') {
      return '';
    }

    const json = JSON.stringify(payload);
    const base64 = btoa(unescape(encodeURIComponent(json)));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }

  public static decodePublicQueryToken(token: string): any {
    if (!token || typeof token !== 'string') {
      return null;
    }

    try {
      let normalized = token.replace(/-/g, '+').replace(/_/g, '/');
      while (normalized.length % 4 !== 0) {
        normalized += '=';
      }
      const json = decodeURIComponent(escape(atob(normalized)));
      return JSON.parse(json);
    } catch (error) {
      return null;
    }
  }

  public static getMonthName(month: number) {
    const months = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
    ];
    return months[month -1];
}
  public static generateInvoiceNo(membershipNoOrVisitorName, feeDetails, currentYear, currentMonth, isVisitor = false, counterCheck = 1) {

    let invoice;
    let counter = 1;
    let visitorMonth;
    let visitorYear;
    let memberMonth;
    let memberYear;
    if (isVisitor == false) {
      let sortedFiltered = feeDetails
        .filter(result => {
          const date = new Date(result.date);
          memberMonth = date.getMonth() + 1;
          memberYear = date.getFullYear();
          return memberMonth == currentMonth && memberYear == currentYear;
        }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

      if (sortedFiltered.length > 0 && sortedFiltered[0].invoice) {
        let splitedArray = sortedFiltered[0].invoice.trim().split('-');
        if (splitedArray.length > 4) {
          counter = Number(splitedArray[4]) + counterCheck;
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        } else {
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        }
      } else {
        invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counterCheck}`;
      }
      return invoice;
    } else {
      let sortedFiltered = feeDetails
        .filter(result => {
          const date = new Date(result.date);
          visitorMonth = date.getMonth() + 1;
          visitorYear = date.getFullYear()
          return visitorMonth == currentMonth && visitorYear == currentYear;
        }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

      if (sortedFiltered.length > 0 && sortedFiltered[0].invoice) {
        let splitedArray = sortedFiltered[0].invoice.trim().split('-');
        if (splitedArray.length > 4) {
          counter = Number(splitedArray[4]) + 1;
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        } else {
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        }
      } else {
        invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
      }
      return invoice;
    }
  }
  public static base64ToFile(data, filename) {

    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
        ;
    }
    return new File([u8arr], filename, { type: mime });
  }
}
